import { useUserInfo } from '../use-userInfo'
import { numberOfPointsToEnterTheLeague } from './useUserLeagueInfo.constants'
import { useLeaguePointsQuery } from '__gql-generated__/types'

export const useUserLeagueInfo = () => {
  const { user } = useUserInfo()
  const { data, loading } = useLeaguePointsQuery({
    skip: !user.canAccessLeagueContent
  })

  const { getCurrentPoints, overallRanking } = data?.me?.reader || {}
  const { points, tier, percentage } = overallRanking || {}

  const userDontHaveEnoughPoints = getCurrentPoints
    ? getCurrentPoints < numberOfPointsToEnterTheLeague
    : true
  const userWaitingToEnterLeague = points === null && !userDontHaveEnoughPoints

  return {
    userDontHaveEnoughPoints,
    userWaitingToEnterLeague,
    pointsToShow: points || getCurrentPoints || 0,
    percentage: percentage ? percentage * 100 : 0,
    tier,
    loading
  }
}
